
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/token/[hash]",
      function () {
        return require("private-next-pages/token/[hash]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/token/[hash]"])
      });
    }
  